<ng-container *transloco="let t; read: 'home'">
  <div class="login-header">
    <img class="login-image" src="assets/logo/JOW.svg" alt="Justice banner image">
    <div class="login-title">{{t('title')}}</div>
    <div class="login-description" [innerHTML]="t('logon-choice')"></div>
  </div>

  <div class="login-container">
    <div class="cards">
      <div class="login-card">
        <div class="card-icon">
          <img class="resize" src="assets/logo/citizen.svg" alt="citizen icon"/>
        </div>
        <div class="card-title">{{t('civilian')}}</div>
        <div class="card-actions">
          <jow-button (click)="navigateToLoginUrl(LoginType.Citizen)">{{t('logon')}}</jow-button>
        </div>
      </div>
      <div class="login-card">
        <div class="card-icon">
          <img class="resize" src="assets/logo/organisation.svg" alt="organisation icon"/>
        </div>
        <div class="card-title">{{t('institution')}}</div>
        <div class="card-actions">
          <jow-button (click)="navigateToLoginUrl(LoginType.Organisation)">{{t('logon')}}</jow-button>
        </div>
      </div>
      <div class="login-card">
        <div class="card-icon">
          <img class="resize" src="assets/logo/lawyer.svg" alt="lawyer icon"/>
        </div>
        <div class="card-title">{{t('lawyer')}}</div>
        <div class="card-actions">
          <div class="card-actions">
            <jow-button (click)="navigateToLoginUrl(LoginType.LawyerCard)">{{t('logon-advocate-card')}}</jow-button>
          </div>
          <div class="card-actions">
            <jow-button (click)="navigateToLoginUrl(LoginType.Lawyer)">{{t('logon-eid')}}</jow-button>
          </div>
          <div class="card-actions">
            <jow-button (click)="navigateToLoginUrl(LoginType.Staff)">{{t('logon-medewerker')}}</jow-button>
          </div>
        </div>
      </div>
      <div class="login-card">
        <div class="card-icon">
          <img src="assets/imgs/justice-logo.svg" alt="Justice icon"/>
        </div>
        <div class="card-title">{{t('clerk')}}</div>
        <div class="card-actions">
          <jow-button (click)="navigateToLoginUrl(LoginType.Justice)">{{t('logon')}}</jow-button>
        </div>
      </div>
    </div>

    <div class="help-card">
      <div class="help-title">{{t('help-contact.title')}}</div>
      <a routerLink="/help" target="_blank">{{t('help-contact.page')}}</a>
      <div class="contact-tel">
        <div>{{t('help-contact.body')}}</div>
        <a href="tel:+3222785560">+32 (0)2 278 55 60</a>
        <div>{{t('help-contact.info')}}</div>
        <div>{{t('help-contact.footer')}}</div>
      </div>
      <a routerLink="/whats-new" queryParamsHandling="merge" target="_blank">{{t('help-contact.whats-new')}}</a>
    </div>
  </div>
</ng-container>
